import script from "./InputOnlyNumberMixin.vue?vue&type=script&lang=ts"
export * from "./InputOnlyNumberMixin.vue?vue&type=script&lang=ts"

export default script